<template>
  <div>
    <div>
      <span>
        <Button
          @click="viewAllRoutes = !viewAllRoutes"
          background="white"
          style="color: #fcc210"
          text="View"
          class="float-right"
        />
        <span class="float-right mt-2"
          >Selected Route ({{ selectedRoute.length }})</span
        >
      </span>
    </div>
    <div class="custom-card">
      <b-table-simple head-row-variant="primary" small outlined responsive="sm">
        <template #table-caption>This is a table caption.</template>
        <b-thead>
          <b-tr class="" style="background-color: #dae8f6">
            <b-th>Cost Element 2</b-th>
            <b-th class="w-64">Base Rate (Naira/Kg/Km)</b-th>
            <b-th class="w-64">Base Multiplier</b-th>
            <b-th></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="item in costElementField"
            :key="item.name"
            style="border-bottom: 1px solid #dae8f6"
          >
            <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
              item.name
            }}</b-td>
            <b-td class="td-2-3" style="border-right: solid 1px #dae8f6">{{
              constantValues.base_rate
            }}</b-td>
            <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
              >{{ item.multiplier }}
              <span @click="selectElement(item)" class="float-right"
                ><img src="@/assets/images/icons/edit-box.svg" alt="" /></span
            ></b-td>
            <b-td style="border-right: solid 1px #dae8f6; align-item: center">
              <tooltip text="Restore Default">
                <span @click="restoreDefault(item)" class="text-center">
                  <img src="@/assets/images/icons/refresh.png" alt="" />
                </span>
              </tooltip>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <div class="custom-card" style="border-bottom: 1px solid #dae8f6">
      <div class="my-1">
        <strong>Advanced Settings</strong>
        <span @click="advanced = false" v-if="advanced" class="float-right">
          <img src="@/assets/images/icons/arrow-up.png" alt="" />
        </span>
        <span v-else @click="advanced = true" class="float-right">
          <img src="@/assets/images/icons/down.png" alt="" />
        </span>
      </div>

      <div v-if="advanced" class="mx-0">
        <b-table-simple
          head-row-variant="primary"
          small
          class=""
          outlined
          responsive="sm"
        >
          <b-thead>
            <b-tr class="" style="background-color: #dae8f6">
              <b-th class="">Cost Element</b-th>
              <b-th class="w-64">Standard Rate </b-th>
              <b-th class="w-64">Adjusted Rate</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="item in advancedField"
              :key="item.name"
              style="border-bottom: 1px solid #dae8f6"
            >
              <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
                item.name
              }}</b-td>
              <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                >{{ item.standardRate }}%</b-td
              >
              <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                >{{ item.adjustedRate }}%
                <span @click="selectAdvanceElement(item)" class="float-right"
                  ><img src="@/assets/images/icons/edit-box.svg" alt="" /></span
              ></b-td>
              <b-td style="border-right: solid 1px #dae8f6; align-item: center">
                <tooltip text="Restore Default">
                  <span @click="restoreAdjustedRate(item)">
                    <img src="@/assets/images/icons/refresh.png" alt="" />
                  </span>
                </tooltip>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="container my-5">
      <div class="row my-3">
        <div class="col-md-6 px-2">
          <span class="text-2xl font-semibold">Economy Discount</span>
        </div>
        <div class="col-md-6 px-2">
          <span class="text-2xl font-semibold">Express Mark-up</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 px-4">
          <div class="my-3">
            <p class="text-sm font-normal" v-if="Math.sign(economyIndicator.percentageDifference)===1">
              Your prices are <span class="text-danger text-semibold">{{economyIndicator.percentageDifference}}% higher</span> than
              MuleEx recommended average price.
            </p>
            <p class="text-sm font-normal" v-if="Math.sign(economyIndicator.percentageDifference)===-1">
              Your prices are <span class="text-danger">{{Math.abs(economyIndicator.percentageDifference)}}% lower</span> than
              MuleEx recommended average price.
            </p>
            <p class="text-sm font-normal" v-if="economyIndicator.percentageDifference === 0">
              Great! you have adopted MuleEx Recommended average price.
            </p>
          </div>
          <div class="row px-4 custom-card shadow" style="width: 488px">
            <div class="col-md-6"><span>Economy Shipping</span></div>
            <div class="col-md-2">
              <b-form-checkbox
                v-model="enableEconomy"
                name="check-button"
                switch
              >
              </b-form-checkbox>
            </div>
            <div class="col">
              <span
                :class="[enableEconomy ? 'text-danger' : 'text-black-50']"
                class="mr-2"
                >{{ economyRate }}%</span
              >
              <input
                type="number"
                :disabled="enableEconomy === false"
                v-model="economyRate"
                class="border-0 text-light w-1/6"
                value="%"
                name=""
                id=""
              />
            </div>
          </div>
        </div>
        <div class="col-md-6 px-4">
          <div class="my-3">
            <p class="text-sm font-normal" v-if="Math.sign(expressIndicator.percentageDifference)===1">
              Your prices are <span class="text-danger text-semibold">{{expressIndicator.percentageDifference}}% higher</span> than
              MuleEx recommended average price.
            </p>
            <p class="text-sm font-normal" v-if="Math.sign(expressIndicator.percentageDifference)===-1">
              Your prices are <span class="text-danger">{{Math.abs(expressIndicator.percentageDifference)}}% lower</span> than
              MuleEx recommended average price.
            </p>
            <p class="text-sm font-normal" v-if="expressIndicator.percentageDifference === 0">
              Great! you have adopted MuleEx Recommended average price.
            </p>
          </div>
          <div class="row px-4 custom-card shadow" style="width: 488px">
            <div class="col-md-6"><span>Express Shipping</span></div>
            <div class="col-md-2">
              <b-form-checkbox
                v-model="enableExpress"
                name="check-button"
                switch
              >
              </b-form-checkbox>
            </div>
            <div class="col">
              <span
                class="mr-2"
                :class="[enableExpress ? 'text-danger' : 'text-black-50']"
                >{{ expressRate }}%
              </span>
              <input
                type="number"
                :disabled="enableExpress === false"
                v-model="expressRate"
                class="border-0 text-light w-1/6"
                value="%"
                name=""
                id=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <p>
        Good-in-Transit & other necessary insurance shall be taken out by MuleEx
        annually and charged a fixed percentage per booking to recoup the cost
        of insurance.
      </p>
    </div>
    <div class="mt-5">
      <Button text="Cancel" @click="$emit('cancel')" background="white" />
      <Button
        :loading="btnLoading"
        class="float-right"
        @click="createBillingSetting()"
        text="Save"
      />
    </div>

    <!-- Edit cost element modal -->
    <modal
      v-if="selectedElement"
      @close-modal="editModal = false"
      :showModal="editModal"
      id="editModal"
      width="auto"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Enter {{ selectedElement.name }} Multiplier
              </label>
              <base-input
                style="width: 207px"
                type="text"
                v-model="selectedElement.multiplier"
                name="multiplier"
                placeholder="Enter New Base Multiplier"
                required="true"
                error="Enter New Base Multiplier"
                width="50"
              >
              </base-input>
            </span>
          </div>
          <div class="col-md-6 mt-4">
            <Button
              @click="saveEdit"
              text="Save"
              type="submit"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- Edit advance setting -->
    <modal
      v-if="selectedAdvanceElement"
      @close-modal="editAdvanceModal = false"
      :showModal="editAdvanceModal"
      id="editAdvanceModal"
      width="auto"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Enter {{ selectedAdvanceElement.name }} Adjusted Rate
              </label>
              <base-input
                style="width: 207px"
                type="text"
                v-model="selectedAdvanceElement.adjustedRate"
                name="multiplier"
                placeholder="Enter New Base Multiplier"
                required="true"
                error="Enter New Adjusted Rate"
                width="50"
              >
              </base-input>
            </span>
          </div>
          <div class="col-md-6 mt-4">
            <Button
              @click="saveAdvanceEdit"
              text="Save"
              type="submit"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- view selected route modal -->
    <modal
      @close-modal="viewAllRoutes = false"
      :showModal="viewAllRoutes"
      id="selectRoute"
      width="21.9"
    >
      <div>
        <h4 class="font-weight-bold">Selected Route</h4>
        <div class="mx-2">
          <div class="my-2">
            <b-form-group>
              <template v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="routes"
                  v-model="selectedRoute"
                  :options="selectedRoute"
                  :aria-describedby="ariaDescribedby"
                  name="routes"
                  class=""
                  aria-label="Individual routes"
                  stacked
                ></b-form-checkbox-group>
              </template>
            </b-form-group>
          </div>
          <div class="my-3">
            <Button
              @click="viewAllRoutes = false"
              class="mr-1 border border-black"
              text=" close"
              background="white"
            />
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/UI/Modal/index.vue";
import Tooltip from "../../Tooltip.vue";

import Button from "@/components/UI/BaseButton.vue";
export default {
  props: ["selectedRoute", "routesId"],
  components: {
    Button,
    Modal,
    Tooltip,
  },
  data() {
    return {
      enableEconomy: true,
      enableExpress: false,
      expressIndicator: null,
      economyIndicator: null,
      economyRate: -20,
      expressRate: 20,
      btnLoading: false,
      shippingServices: [],
      selected: [],
      allSelected: true,
      editModal: false,
      editAdvanceModal: false,
      selectedElement: null,
      selectedAdvanceElement: null,
      costElementField: [
        {
          name: "Gross Weight (Cost Per Kg per Km)",
          baseRate: null,
          payload: "gross_weight_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Land (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_land_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Air (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_air_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Rail (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_rail_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Sea (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_sea_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Parcel",
          baseRate: null,
          payload: "haulage_base_rate",
          multiplier: null,
        },
        {
          name: "Haulage",
          baseRate: null,
          payload: "haulage_base_rate",
          multiplier: null,
        },
      ],
      advancedField: [
        {
          name: "Fragility",
          standardRate: 15,
          payload: "imflammable",
          adjustedRate: null,
        },
        {
          name: "Inflammable",
          standardRate: 25,
          payload: "fragile",
          adjustedRate: null,
        },
        {
          name: "Radioactive",
          standardRate: 25,
          payload: "radioactive",
          adjustedRate: null,
        },
        {
          name: "Oversized",
          standardRate: 20,
          payload: "oversized",
          adjustedRate: null,
        },
        {
          name: "Overweight",
          standardRate: 10,
          payload: "overweight",
          adjustedRate: null,
        },
        {
          name: "Packaging & Handling",
          standardRate: 10,
          payload: "packageHandling",
          adjustedRate: null,
        },
      ],
      constantValues: [],
      payload: {
        shippingServices: [
          "2b4daeab-68c7-49aa-bd44-0a763e535450",
          "006f3aa0-91ef-44e0-88db-6a7a6a3eec47",
          "36403356-1746-4c2e-a222-7385c157858d",
        ],
        surgeMultipler: 1,
        vat_rate: 7.5,
        tran_type: "inter",
        orgId: "eb62e41a-3387-4cb2-befa-2b5f2a7b2f18",
        user_id: "1861633d-cf0f-4579-b9e1-165df3c976db",
        package_type: "single",
        fragile: 15,
        imflammable: 25,
        radioactive: 25,
        dangerous: 20,
        oversized: 10,
        overweight: 10,
        packageHandling: 3,
        gross_weight_cost_multiplier: 1,
        volume_weight_land_cost_multiplier: 1,
        volume_weight_air_cost_multiplier: 1,
        volume_weight_rail_cost_multiplier: 1,
        volume_weight_sea_cost_multiplier: 1,
      },
      indeterminate: false,

      viewAllRoutes: false,

      advanced: false,
      fields: [
        {
          label: "Cost Element",
          key: "cost",
        },
        {
          label: "Base Rate/Kg",
          key: "rate",
        },
        {
          label: "Base Multiplier",
          key: "multiplier",
        },
      ],
      items: [
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
      ],
      baseRate : "",
    };
  },
  watch: {
    economyRate(val) {
      if(val < -20){
        this.economyRate = -20
        return
      }
      this.priceIndicator({
        percentage: val,
        type: "economy",
      });
    },
    expressRate(val) {
      if(val > 20){
        this.expressRate = 20
        return
      }
      this.priceIndicator({
        percentage: val,
        type: "express",
      });
    },
  },
  mounted() {
    this.getRates();
    this.getData();
    this.getAdvanceData();
    this.getAllRoutes();
    this.checkEconomyPrice();
    this.checkExpressPrice();
  },
  computed: {
    baseRateHaulage(){
      return 4000;
    }
  },
  methods: {
    async checkEconomyPrice() {
      await this.priceIndicator({
        percentage: this.economyRate,
        type: "economy",
      });
    },
    async checkExpressPrice() {
      await this.priceIndicator({
        percentage: this.expressRate,
        type: "express",
      });
    },
    async priceIndicator(payload) {
      try {
        const response = await this.$_priceIndicator(payload);
        console.log(JSON.stringify(response, null, 2));
        if (response.data.data.type === "economy") {
          this.economyIndicator = response.data.data;
        } else if (response.data.data.type === "express") {
          this.expressIndicator = response.data.data;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    restoreDefault(item) {
      let index = this.costElementField.findIndex(
        (el) => el.payload === item.payload
      );
      this.costElementField[index].multiplier = 1;
      this.payload[item.payload] = 1;
    },
    restoreAdjustedRate(item) {
      let index = this.advancedField.findIndex(
        (el) => el.payload === item.payload
      );
      this.advancedField[index].adjustedRate =
        this.constantValues[item.payload];
      this.payload[item.payload] = this.constantValues[item.payload];
    },
    saveEdit() {
      let index = this.costElementField.findIndex(
        (el) => el.payload === this.selectedElement.payload
      );
      this.costElementField[index].multiplier = this.selectedElement.multiplier;
      this.payload[this.selectedElement.payload] =
        this.selectedElement.multiplier;
      this.editModal = false;
    },
    saveAdvanceEdit() {
      let index = this.advancedField.findIndex(
        (el) => el.payload === this.selectedAdvanceElement.payload
      );
      this.advancedField[index].adjustedRate =
        this.selectedAdvanceElement.adjustedRate;
      this.payload[this.selectedAdvanceElement.payload] =
        this.selectedAdvanceElement.adjustedRate;
      this.editAdvanceModal = false;
    },
    getData() {
      for (let index = 0; index < this.costElementField.length; index++) {
        const element = this.costElementField[index];
        this.costElementField[index].multiplier = this.payload[element.payload];
      }
    },
    async getAllRoutes(params) {
      try {
        let response = await this.$_getAllRoutes(params);

        this.shippingServices = response.data.data.shippingServices
          .filter((route) => this.selectedRoute.includes(route.routeName))
          .map((route) => route.id);

        // this.totalRoutes = response.data?.data?.totalCount
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    getAdvanceData() {
      for (let index = 0; index < this.advancedField.length; index++) {
        const element = this.advancedField[index];
        this.advancedField[index].adjustedRate = this.payload[element.payload];
      }
    },
    selectElement(e) {
      this.selectedElement = { ...e };
      this.editModal = true;
    },
    selectAdvanceElement(e) {
      this.selectedAdvanceElement = { ...e };
      this.editAdvanceModal = true;
    },
    async getRates() {
      try {
        let response = await this.$_getBillingRate();
        this.constantValues = response.data.data.mulexBillingSetting;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async createBillingSetting() {
      try {
        this.btnLoading = true;
        let orgId = localStorage.getItem("organizationId");
        let userId = localStorage.getItem("userId");
        let payload = {
          shippingServices: this.shippingServices,
          surgeMultipler: this.constantValues.surgeMultipler,
          vat_rate: this.constantValues.vat_rate,
          tran_type: "inter",
          enableEconomy: this.enableEconomy,
          enableExpress: this.enableExpress,
          economyRate: this.economyRate,
          expressRate: this.expressRate,
          orgId: orgId,
          user_id: userId,
          package_type: "single",
          fragile: this.payload.fragile,
          imflammable: this.payload.imflammable,
          radioactive: this.payload.radioactive,
          oversized: this.payload.oversized,
          overweight: this.payload.overweight,
          packageHandling: this.payload.packageHandling,
          gross_weight_cost_multiplier:
            this.payload.gross_weight_cost_multiplier,
          volume_weight_land_cost_multiplier:
            this.payload.volume_weight_land_cost_multiplier,
          volume_weight_air_cost_multiplier:
            this.payload.volume_weight_air_cost_multiplier,
          volume_weight_rail_cost_multiplier:
            this.payload.volume_weight_rail_cost_multiplier,
          volume_weight_sea_cost_multiplier:
            this.payload.volume_weight_sea_cost_multiplier,
        };
        await this.$_createBillingSetting(payload);
        this.$emit("cancel");
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      } finally {
        this.btnLoading = false;
      }
    },
    toggleAll(checked) {
      this.selected = checked ? this.selectedRoute.slice() : [];
    },
  },
};
</script>
<style scoped>
.tooltip-refresh {
  background: white;
}
.td1 {
  min-width: 440px;
  max-width: 440px;
}
.td2-3 {
  min-width: 200px;
  max-width: 200px;
  width: 192px;
}
</style>
